import React, { useState, useRef, useEffect } from 'react';
import Header from "./Header";
import GridBackground from "../../ui/Linegrid";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function HeroSection({ currentHeroImg }) {
  const videoRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (videoRef.current && loaded) {
      const p = videoRef.current.play();
      if (p && p.catch) p.catch(() => { /* autoplay blocked, ignore */ });
    }
  }, [loaded]);

  return (
    <GridBackground className="bg-bg-60 min-h-screen relative overflow-hidden">
      <Header />

      {/* Matching header horizontal spacing: w-[90%] max-w-6xl same as header */}
      <div className="w-[90%] max-w-6xl mx-auto pt-40">
        <div className="flex flex-col items-start text-left gap-8">
          {/* Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-fg-40 leading-tight">
            Intelligent Conversations
            <br />
            <span className="text-fg-40 mt-2 block">Powered by AI</span>
          </h1>

          {/* Subtext */}
          <p className="mt-4 text-base md:text-lg text-fg-60 max-w-md">
            Experience the future of communication with our advanced AI chatbot.
            Get instant responses and human-like conversations.
          </p>

          {/* Buttons */}
          <div className="mt-4 flex gap-3 flex-col sm:flex-row sm:flex-wrap sm:justify-start justify-center w-full">
            <Link
              to="/chat"
              className="px-6 py-3 bg-ac-02 text-white dark:text-black rounded-full text-sm font-medium hover:bg-ac-01 transition flex items-center justify-center gap-2 whitespace-nowrap min-w-[140px]"
            >
              Try Chat Free
              <ArrowRight size={16} />
            </Link>

            <Link
              to="/register"
              className="px-6 py-3 border border-bd-50 text-fg-40 rounded-full text-sm font-medium bg-bg-70 hover:bg-bg-50 transition flex items-center justify-center gap-2 whitespace-nowrap min-w-[140px]"
            >
              Get Started
              <ArrowRight size={16} />
            </Link>

            <Link
              to="/contact"
              className="px-6 py-3 border border-bd-50 text-fg-40 rounded-full text-sm font-medium bg-bg-70 hover:bg-bg-50 transition flex items-center justify-center gap-2 whitespace-nowrap min-w-[140px]"
            >
              Contact Us
              <ArrowRight size={16} />
            </Link>
          </div>

          {/* Video Below */}
          <div className="w-full flex justify-center mt-4">
            {/* Desktop Video */}
            <video
              ref={videoRef}
              src="/Introduction Video - AI VO - English.mp4"
              poster="/path/to/poster.jpg"
              preload="auto"
              className="hidden md:block max-w-full h-auto rounded-xl"
              style={{ maxHeight: "800px", opacity: loaded ? 1 : 0, transition: "opacity 300ms ease" }}
              controls={loaded}
              muted
              autoPlay
              loop
              playsInline
              onCanPlay={() => setLoaded(true)}
            >
              Your browser does not support the video tag.
            </video>

            {/* Mobile Video */}
            <video
              src="/Introduction Video - AI VO - English - Reel.mp4"
              poster="/path/to/poster.jpg"
              preload="auto"
              className="block md:hidden w-full max-w-sm h-auto rounded-xl mx-auto"
              style={{ maxHeight: "600px", opacity: loaded ? 1 : 0, transition: "opacity 300ms ease" }}
              controls={loaded}
              muted
              autoPlay
              loop
              playsInline
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </GridBackground>
  );
}
